import React, { useState } from 'react';
import './NetworkSwitcher.css';

const NetworkSwitcher = ({ currentNetwork, onNetworkChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const networks = [
    {
      id: 'mainnet',
      name: 'Mainnet',
      rpcUrl: 'http://localhost:9545',
      chainId: 1,
      explorer: 'https://avoscan.io'
    },
    {
      id: 'testnet',
      name: 'Testnet',
      rpcUrl: 'http://localhost:9545',
      chainId: 9999,
      explorer: 'https://testnet.avoscan.io'
    },
    {
      id: 'devnet',
      name: 'Devnet',
      rpcUrl: 'http://localhost:9545',
      chainId: 9998,
      explorer: 'http://localhost:3000'
    }
  ];

  const activeNetwork = networks.find(n => n.id === currentNetwork) || networks[2];

  const handleNetworkSelect = (network) => {
    onNetworkChange(network);
    setIsOpen(false);
  };

  return (
    <div className="network-switcher">
      <button 
        className="network-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="network-name">{activeNetwork.name}</span>
      </button>

      {isOpen && (
        <div className="network-dropdown">
          {networks.map(network => (
            <div
              key={network.id}
              className={`network-option ${network.id === currentNetwork ? 'active' : ''}`}
              onClick={() => handleNetworkSelect(network)}
            >
              <div className="network-info">
                <div className="network-option-name">{network.name}</div>
                <div className="network-chain-id">Chain {network.chainId}</div>
              </div>
              {network.id === currentNetwork && (
                <span className="check-mark">●</span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NetworkSwitcher;
